import type { mapFactoryInit } from 'components/map/factory/main.js';
import { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export type MapFactoryType = Awaited<ReturnType<typeof mapFactoryInit>>;

export const LeafletContext = createContext<MapFactoryType | undefined>(undefined);

export const LeafletProvider = ({ children }: { children: JSX.Element }) => {
  const [map, setMap] = useState<MapFactoryType>();
  const navigation = useNavigate();

  useEffect(() => {
    if (!map) {
      const lazyLoadMap = async () => {
        const { default: mapFactoryInit } = await import(
          /* webpackChunkName: "draw-map" */
          'lazy/components.lazy/draw-map.js'
        );
        const newMap = await mapFactoryInit({ navigation });
        setMap(newMap);
      };
      lazyLoadMap();
    }
  }, [map]);

  if (map) {
    return <LeafletContext.Provider value={map}>{children}</LeafletContext.Provider>;
  }
  return <LeafletContext.Provider value={undefined}>{children}</LeafletContext.Provider>;
};
